import type { Embed, Qobuz } from '@tunasong/models'
import type { EmbedSizes } from './types.js'

/** Example URLs
 *
 * https://open.qobuz.com/track/19512574
 * https://open.qobuz.com/album/19512574
 * https://open.qobuz.com/playlist/19512574
 * https://www.qobuz.com/us-en/album/title/19512574
 *
 * Embed URL format:
 * https://widget.qobuz.com/track/19512574?display=compact
 */

const openUrlMatch = /^https:\/\/open\.qobuz\.com\/(track|album|playlist)\/([\w-]+)\/?(\?.*)?$/
const wwwUrlMatch = /^https:\/\/(?:www\.)?qobuz\.com\/[\w-]+\/(track|album|playlist)\/[\w-]+\/([\w-]+)\/?(\?.*)?$/

const sizes: EmbedSizes = {
  small: {
    width: '50%',
    height: '100px',
  },
  medium: {
    width: '100%',
    height: '100px',
  },
  large: {
    width: '100%',
    height: '500px',
  },
}

export const parseQobuzLink = (urlOrUrn?: string): Embed | null => {
  if (!urlOrUrn) {
    return null
  }
  const trimmed = urlOrUrn.trim()
  const match = trimmed.match(openUrlMatch) ?? trimmed.match(wwwUrlMatch)
  const mediaType = match?.[1] as Qobuz['mediaType']
  const mediaId = match?.[2]
  if (!(mediaId && mediaType)) {
    return null
  }
  const node: Qobuz = {
    type: 'embed',
    service: 'qobuz',
    url: `https://widget.qobuz.com/${mediaType}/${mediaId}?zone=us-en`,
    mediaId,
    mediaType,
    size: 'medium',
    children: [{ text: '' }],
  }

  return node
}

const getUrlForSize = (embed: Embed, size: keyof typeof sizes): string | undefined => {
  if (!embed.url) {
    return embed.url
  }

  try {
    const url = new URL(embed.url)
    if (size === 'small' || size === 'medium') {
      url.searchParams.set('display', 'compact')
    } else {
      url.searchParams.delete('display')
    }
    return url.toString()
  } catch {
    return embed.url
  }
}

export default {
  parse: parseQobuzLink,
  sizes,
  getUrlForSize,
}
